export interface DataLayerTypes {
  event: string;
  method?: string;
  value?: number | null;
  action?: string;
  service?: string;
  source?: string;
  bannerId?: number;
  workId?: number;
  numberOfMonths?: number;
  formRate?: string | null;
  formCategory?: string;
  movies?: string | null;
}

export enum DataLayerEvents {
  TOP_UP_BALANCE = 'top_up_balance',
  SERVICE_PAYMENT = 'service_payment',
  SERVICE_PAYMENT_PAUSE = 'service_payment_pause',
  FORM_SUBMIT = 'formSubmit',
  SHOW_REPAIR_WORKS = 'show_repair_works',
  REPAIR_WORK_BUTTON_CLICK = 'repair_work_button_click',
  SMS_NOTIFICATIONS = 'sms_notifications',
  EMAIL_NOTIFICATIONS = 'email_notifications',
  MAIN_BANNER_CLICK = 'main_banner_click',
  BANNER_CLICK = 'banner_click',
}

export enum DataLayerMethods {
  BANK_CARD = 'bank_card',
  SCRATCH_CARD = 'scratch_card',
}

export enum DataLayerActions {
  OPEN = 'open',
  SUCCESSFUL_PAYMENT = 'successful_payment',
  SERVICE_PAUSE = 'service_pause',
  OPEN_ALL_OFFERS = 'open_all_offers',
  HURRY_UP_MASTERS = 'hurry_up_masters',
  ON = 'on',
  OFF = 'off',
}

export enum DataLayerFormCategories {
  HOME_INTERNET = 'home_internet',
  CALL_ME = 'callMe',
  BRIZ_TV_TRIAL = 'BRIZTV_14days_free',
}

export enum DataLayerButtonsTypes {
  GO_TO_ACTIVATION = 'button_goToActivation',
  ACTIVATE = 'button_activate',
  CONNECT = 'button_connect',
}

export type NotificationsTypes = 'sms' | 'email';
export type MoviesActivatedTypes = 'Yes' | 'No';
